import React from 'react';
import "./index.css";
import {Card, CardHeader, CardText} from 'material-ui/Card';

const FAQPage =  () => {
    const generalQuestionAnswers = [
        {
            question: "What does this site do?",
            answer: "This site provides a way for students to submit evaluations — as defined by their teachers — about other students. Teachers can give feedback on those evaluations to check for quality and completeness. Students can then revise their evaluations based off of teacher feedback. This site also comes with the ability to generate a report so that students can see the feedback that other students have submitted about them, along with how well they did in relation to the rest of the class. Teachers will also receive a report about their class's statistics."
        },
        {
            question: "A complete guide to finding your evaluations.",
            answer: [
                `It all depends where the evaluation is in its lifecycle.`,

                `Assigned / Unsubmitted`,
                
                `If a teacher has created an assignment, then its evaluation will be available
                for a student to submit under the 'Reviews to Submit'.`,

                `Submitted`,
                
                `Once a student has submitted an evaluation, a student can view it by clicking on 
                'View Submitted Reviews', which is level with Reviews to Submit, but off to 
                the right, in pink. On that page, it will be under 'Submitted Reviews'. At 
                this point, it is ready for the teacher to grade. On the teacher dashboard,
                the teacher can click the tile(s) under 'Reviews to Grade' to go to the 
                grading page. On this page, there are filters on the top-right. Select 
                'Reviews to Grade'.`,

                `Graded`,

                `Once a teacher submits a grade for an evaluation, it as marked as graded. 
                The student can view the tile for it under the 'View Submitted Reviews' 
                page as 'Reviews Being Graded'. However, the tile will be disabled, as the 
                teacher has not released their feedback. The teacher could find this review 
                by clicking on 'View Graded Reviews' on the teacher dashboard, which is even
                with 'Reviews to Submit', but off to the right, in pink. On this page, there
                are filters on the top-right. Select 'Graded'.`,

                `Releasing Feedback`,

                `For the teacher to release their feedback to the students, a teacher would 
                go to the teacher dashboard, choose the correct sprint to view from the 
                dropdown menu, scroll down to the 'Assignments for Sprint <sprint_name>' 
                section, find the tile for the assignment they would like to release, and 
                click 'Release Grades'.`,

                `Ready for Resubmission`,
                
                `At this point, a student can view their grades by going to the student 
                dashboard, scrolling down to 'Graded Reviews to Resubmit', and then click on
                the tile for their graded review. The feedback will be at the top of the page.
                A teacher can view their evaluation released to the student by clicking on 
                'View Graded Reviews' on the teacher dashboard, which is even with 'Reviews to
                Submit', but off to the right, in pink. On this page, there are filters on the
                top-right. Select 'Released for Resubmission'.`,
                
                `Once a student resubmits their evaluation by going to an evaluation under 
                'Graded Reviews to Resubmit', editing it, and clicking submit, it is now 
                considered resubmitted.`,

                'Resubmitted',
                
                `A student can view this resubmitted evaluation by going to the student 
                dashboard clicking on 'View Submitted Reviews', which is level with 'Reviews to
                Submit', but off to the right, in pink. On that page, it will be under 
                'Resubmitted Reviews'. At this point, it is ready for the teacher to regrade.
                On the teacher dashboard, the teacher can click the tile(s) under 'Reviews to 
                Grade' to go to the grading page. On this page, there are filters on the
                top-right. Select 'Reviews to Regrade'.`,
                
                `Once a teacher submits a grade for a re-evaluation, it as marked as regraded.`,

                `Regraded`,

                `The student can view the tile for it under the 'View Submitted Reviews' page as
                'Reviews Being Regraded'. However, the tile will be disabled, as the teacher 
                has not released their feedback. The teacher could find this review by clicking 
                on 'View Graded Reviews' on the teacher dashboard, which is even with 'Reviews 
                to Submit', but off to the right, in pink. On this page, there are filters on 
                the top-right. Select 'Regraded'.`,

                `Finally, an evaluation a sprint is released, and all evaluations are also
                released.`,
                
                `Released`,
                
                `The student can view the tile for it under the 'View Submitted Reviews' 
                page as 'Released Reviews'. The teacher could find this review by clicking 
                on 'View Graded Reviews' on the teacher dashboard, which is even with 'Reviews 
                to Submit', but off to the right, in pink. On this page, there are filters on 
                the top-right. Select 'Released for Report'.`,

                `Reports are also generated for both students and teachers, which can be viewed
                by scrolling down to the bottom of the dashboard and clicking on a sprint tile
                for the sprint report you wish to view.`
            ]
        },
        {
            question: "How do I update my profile's information: password, email, etc.?",
            answer: "After logging in, navigate to https://negotiationfeedback.herokuapp.com/profile, or click on the Menu icon at the top-right of the screen, then select Profile from the dropdown menu. This will take you to the profile page, where you can update your profile's information, or change your password. Type your changes in the appropriate section and click Save, and you should see a confirmation message."
        }
    ];

    const studentQuestionAnswers = [
        {
            question: "How do I submit a review?",
            answer: "From the student dashboard, click on a tile under Review to Submit. You will be taken to a page where you can submit the evaluation."
        },
        {
            question: "I don't see the assignment I need to submit a review.",
            answer: "If the due date has already passed, you cannot submit a review."
        },
        {
            question: "I need to submit an additional evaluation.",
            answer: "Click the Add evaluation button. You'll be able to choose the assignment you are submitting for from the dropdown menu. The evaluation is the same from that point on."
        },
        {
            question: "How do I see my submitted reviews?",
            answer: "From the student dashboard, click on View Submitted Reviews, which is level with Reviews to Submit, but off to the right, in pink."
        },
        {
            question: "Can I edit my submitted reviews?",
            answer: "Yes. From the student dashboard, click on View Submitted Reviews, which can be level with Reviews to Submit, but off to the right. On that page, you will see tiles that will take you to the evaluation page for that evaluation. As long as it's before the deadline, you will be able to edit your review."
        },
        {
            question: "Can I delete my reviews?",
            answer: "Yes. From the student dashboard, click on View Submitted Reviews, which can be level with Reviews to Submit, but off to the right. On that page, you will see tiles that will take you to the evaluation page for each evaluation. At the bottom of the page, click on the Delete button."
        },
        {
            question: "Can I submit partially-completed reviews?",
            answer: "No. You have to submit completed reviews. If you need more time to think of an answer, you could input a filler answer and edit your review later. This isn't recommended, however."
        },
        {
            question: "How do I see my feedback?",
            answer: "When your teacher releases feedback, your evaluation will appear in the Graded Reviews to Resubmit category on the main page. When you click on the tile, it will take you to the evaluation page with your teacher's grade and feedback at the top of the page."
        },
        {
            question: "How do I see other students' feedback?",
            answer: "When your teacher has released a sprint, your report will appear as a tile that you may click on under the Reports category."
        },
        {
            question: "How do I see add, remove, or change between classes?",
            answer: "At the top-right of the page is a dropdown menu with your class name. If you click the 3 dots next to it, there are options allowing you to add or remove classes.\n\nYou can change the class you are looking at by clicking the class from the dropdown menu.",
        }
    ];

    const teacherQuestionAnswers = [
        {
            question: "What are sprints and assignments?",
            answer: "A sprint belongs to a particular class. You can make as many sprints as you want for each class. Each sprint acts as a template for all assignments created underneath it. Each assignment within a sprint must have the same questions and answers. The questions for the assignment represent the evaluation form that students must fill out for that assignment. Without going into details, this structure makes it possible for us to deliver anonymous peer feedback."
        },
        {
            question: "How do I change the class I'm viewing?",
            answer: "A list of classes that you are currently signed up for appears in the dropdown menu at the top-right of the page. Click on it to see the list, and select the class you want to view."
        },
        {
            question: "How do I add an existing class to my list of classes?",
            answer: "When you click on the icon with 3 dots at the top-right of the page, next to the class dropdown menu, you will open the option to Manage Classes. Click on it. A list of your classes will appear.\n\nPress the Add Existing Class button and select the class you wish to add, then click Add. To add an existing class is to add yourself as a teacher to it, so that you may view it in the teacher dashboard."
        },
        {
            question: "How do I remove a class from my list?",
            answer: "When you click on the icon with 3 dots at the top-right of the page, next to the class dropdown menu, you will open the option to Manage Classes. Click on it. A list of your classes will appear.\n\nPress the Unsubscribe button in that class's tile. To unsubscribe from a class is to remove yourself as a teacher from it, so it no longer appears on your list of classes."
        },
        {
            question: "How do I create classes?",
            answer: "When you click on the icon with 3 dots at the top-right of the page, next to the class dropdown menu, you will open the option to Manage Classes. Click on it. A list of your classes will appear.\n\nPress the Create New Class button. Fill out the information, then press Create. To create a class is to add an entirely new class into the database, and you will be its first teacher."
        },
        {
            question: "How do I edit a class?",
            answer: "When you click on the icon with 3 dots at the top-right of the page, next to the class dropdown menu, you will open the option to Manage Classes. Click on it. A list of your classes will appear.\n\nClick on the Edit button within the class's tile that you wish to edit. Change the information and press Edit."
        },
        {
            question: "How do I delete a class?",
            answer: "When you click on the icon with 3 dots at the top-right of the page, next to the class dropdown menu, you will open the option to Manage Classes. Click on it. A list of your classes will appear.\n\nClick on the Delete button within the class's tile that you wish to edit. To delete a class is to delete it from the database. Ensure that all of the other teachers in the class are aware of this before you delete it."
        },
        {
            question: "How do I duplicate a class?",
            answer: "When you click on the icon with 3 dots at the top-right of the page, next to the class dropdown menu, you will open the option to Manage Classes. Click on it. Press the Duplicate class button. Select the class you want to copy, enter a name and status for the new class, then click Duplicate. This creates a new class with the same setup as the original."
        },
        {
            question: "When I make an assignment, why do I need to add the number of required reviews?",
            answer: "The site uses this information to generate evaluations for the student to fill. Without adding this number, students will be unable to see what assignments need evaluations, how many evaluations they need to fill out, and when these evaluations are due."
        },
        {
            question: "How do I allow students to resubmit after I grade?",
            answer: "When creating or editing an assignment, check the 'Allow Resubmissions' checkbox. When this is enabled, students can resubmit their evaluation after you have graded and released feedback; they will see it under Graded Reviews to Resubmit on their dashboard."
        },
        {
            question: "How do I manage my student roster?",
            answer: "When you click on the icon with 3 dots at the top-right of the page, next to the class dropdown menu, you will open the option to Manage Students. Click on it. You can click on a student to edit their information or create a new student."
        },
        {
            question: "How do I grade reviews?",
            answer: "Click on the tile(s) under Reviews to Grade. On that page, you will see a list of Reviews to Grade and Reviews to Regrade. At the top-right of the page, you can sort and filter as needed to find the reviews that you want. At the bottom of the page, select the page number and page size that you want. Once you find ther review that you want to grade, select Full Points to give full points, or select Needs Improvement. Fill out the text field that appears, then click Submit."
        },
        {
            question: "How do I confirm that my feedback was saved?",
            answer: "Upon submission, a message will appear at the top of the section you are working on, informing you that your submission was successful. Also, on the teacher dashboard, you may go the page to see all of your graded reviews, and edit them as you please. Click on View Graded Reviews, which is level with Reviews to Grade, but off to the right, in pink."
        },
        {
            question: "How do I edit my feedback?",
            answer: "On the teacher dashboard, click on View Graded Reviews, which is level with Reviews to Grade, but off to the right, in pink. This will take you to a page where you will see tiles for all of your saved feedback. Sort and/or use CTRL + F to find the feedback your looking for, and edit it as you wish."
        },
        {
            question: "How do I release my feedback?",
            answer: "On the teacher dashboard, under Assignments, you will see tiles for each assignment you have created. Click Release Grades for the assignment you wish to release your feedback on. Students will now your feedback under their list of Graded Feedbacks. Although clearly visible on the student page, this site does not come with notifications, so we recommend that you inform your students when feedback is released."
        },
        {
            question: "How do I release student feedback?",
            answer: "Select Release report under the Sprint category. A report will be generated for each student, showing how they did in relation to the rest of the class, as well as allow them to see peer feedback."
        }
    ];

    const mapQuestionAnswers = (item, index) => {
        return (
            <Card style={{textAlign: "left", marginBottom: "10px"}} key={index + "Card"}>
                <CardHeader
                  title={item.question}
                  actAsExpander={true}
                  showExpandableButton={true}
                  titleStyle={{fontSize: "22px", color: "#ef6a6e"}}
                />
                <CardText expandable={true}>
                    {Array.isArray(item.answer) 
                        ? item.answer.map(item => <p style={{ fontSize: "18px" }}>{item}</p>)
                        : <p style={{fontSize: "18px"}}>{item.answer}</p>
                    }
                </CardText>
            </Card>
        );
    };

    return (
        <div className="inputPageContainer">
            <div className="inputPage" style={{maxWidth: "900px"}}>
                <h1 style={{marginBottom: "50px"}}>FAQ</h1>
                <h2 style={{textAlign: "left", fontWeight: "500", fontSize: "26px", margin: "30px 0"}}>General</h2>
                {generalQuestionAnswers.map(mapQuestionAnswers)}
                <h2 style={{textAlign: "left", fontWeight: "500", fontSize: "26px", marginTop: "60px", marginBottom: "30px"}}>Students</h2>
                {studentQuestionAnswers.map(mapQuestionAnswers)}
                <h2 style={{textAlign: "left", fontWeight: "500", fontSize: "26px", marginTop: "60px", marginBottom: "30px"}}>Teachers</h2>
                {teacherQuestionAnswers.map(mapQuestionAnswers)}
            </div>
        </div>
    );
}

export default FAQPage;
